import { IHinhThucActionTypes } from "../../action-types/mien-giam/IHinhThucActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHinhThucReducer } from "../../reducer-model/mien-giam/IHinhThucReducer";
const iniState: IHinhThucReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hinhThucs: [],
};
export const hinhThucReducer = (
  state: IHinhThucReducer = iniState,
  action: IHinhThucActionTypes
): IHinhThucReducer => {
  switch (action.type) {
    case "HINH_THUC_MIEN_GIAM_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HINH_THUC_MIEN_GIAM_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hinhThucs: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_MIEN_GIAM_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HINH_THUC_MIEN_GIAM_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "HINH_THUC_MIEN_GIAM_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_MIEN_GIAM_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "HINH_THUC_MIEN_GIAM_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HINH_THUC_MIEN_GIAM_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_MIEN_GIAM_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        hinhThucEditing: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        hinhThucEditing: undefined,
      };
    case "HINH_THUC_MIEN_GIAM_SELECTED_START":
      return {
        ...state,
        hinhThucSelected: action.payload,
      };

    default:
      return state;
  }
};
